"use server";

import { formsService } from "../services/formsService";
import { extractDomain } from "../utils/domain";
import type { Form } from "../services/formsService";

export async function getFormsAction(
  franchiseeId?: string | null,
  language?: string | null,
  page: string = "home"
): Promise<{
  success: boolean;
  data: Form | null;
}> {
  try {
    const domain = await extractDomain();
    const form = await formsService.fetchByDomain(domain, franchiseeId, language, page);
    return {
      success: !!form,
      data: form,
    };
  } catch (error) {
    console.error("[getFormsAction] Error:", error);
    return {
      success: false,
      data: null,
    };
  }
}
